import { TWILIO_ADMIN_IDENTITY } from '@gtintel/platform-constants';
// From backend serializer projects.v2.serializers.ProjectDetailSerializer
export const project = {
  id: 1,
  name: 'Vagabond',
  code: 'PWM000001',
  additional_info: '',
  batch: null,
  closed_date: null,
  assignment_chats: [],
  currency: '£',
  currency_display: 'GBP',
  description: '\nSubject Name: Filipe C. \nJurisdiction: Brazil \nCorporate Records \nRegistration Documents \nNot Available Online \nIndividual \nRetrieval Fee: Pending Analysis\nAdditional Info: Someting \n',
  end_date: null,
  final_price: '0',
  flags: {
    is_excluded_from_stats: false,
    is_excluded_from_admin_dashboard: false,
    is_excluded_from_billing: false,
    is_excluded_from_slack_notifications: false,
    is_proof_of_concept: false,
    is_research_and_development: false,
    can_be_charged: true,
    can_be_billed: true,
    can_be_matched: true,
    had_hassle_admin: false,
    had_hassle_client: false
  },
  high_level_comments: '',
  jurisdiction: null,
  other_conditions: null,
  partner: null,
  partner_price: '0',
  price_breakdown: null,
  project_type: {
    id: 1,
    name: 'ptype'
  },
  project_type_id: 9,
  request_anonymity: false,
  requested_completion_date: '2022-05-31',
  source: 'standard',
  start_date: undefined,
  status: '1',
  status_display: 'Pending',
  client: {
    id: 2,
    first_name: 'Test',
    last_name: 'Client',
    avatar: undefined,
    team_id: 1,
    team_name: 'Some team',
    role: 1
  },
  client_id: 2,
  tags: [234, 456],
  is_inactive: false,
  deleted_date: undefined,
  qa_required: false,
  created_date: new Date('2022-05-11T21:48:59.273418Z'),
  updated_date: new Date('2022-05-11T21:49:11.474738Z'),
  twilio_client_partner: 'CHbc6aa3433eb8423c945e64b41380cd4c',
  twilio_client_admin: 'CH368e36cbcedb4ea0a7bd235d2d66dd16',
  twilio_partner_admin: 'CH2c59425fe6d24786a76104ce91a00fe7',
  reports: [],
  members: [{
    id: 2,
    first_name: 'Test',
    last_name: 'Client',
    avatar: null,
    team_id: 1,
    role: 1,
    team_name: 'Some team',
    is_active: true
  }, {
    id: 4,
    first_name: 'Test',
    last_name: 'Dual Account',
    avatar: null,
    team_id: 1,
    role: 1,
    team_name: 'Some team',
    is_active: true
  }],
  enable_assignments: false
};
export const files = [{
  date_uploaded: new Date('2022-06-13T18:33:04.264997Z'),
  extension: 'folder',
  id: 17,
  key: 17,
  link: null,
  members: [{
    member_id: 2,
    role: '1'
  }, {
    member_id: 4,
    role: '1'
  }],
  name: 'test',
  ownerId: 0,
  path: 'test/'
}, {
  date_uploaded: new Date('2022-06-09T02:26:18.175845Z'),
  extension: 'csv',
  id: 16,
  key: 16,
  // SonarCloud may complain that this contains a hardcoded credential, but
  // it's safe; the credential has been rotated i.e. it's not used anymore:
  link: 'https://gtis3.s3.amazonaws.com/static/projects/pj-1/82644e01-5d03-4d01-bff7-a9272f89e618.csv.csv?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAVTW6HWUACCIZNEPI%2F20220613%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20220613T192443Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=5271eba6d3066f694313470cee61ec11bf6ec2fff23c89b5c33a9c1a0b15429a',
  members: [{
    member_id: 2,
    role: '1'
  }, {
    member_id: 4,
    role: '1'
  }],
  name: 'csv.csv',
  ownerId: 2,
  path: 'csv.csv'
}];
export const projectMembers = [{
  id: 2,
  first_name: 'Test',
  last_name: 'Client',
  is_creator: true,
  is_muted: false,
  avatar: null,
  team_id: 1,
  role: 1
}, {
  id: 4,
  first_name: 'Test',
  last_name: 'Dual Account',
  is_creator: false,
  is_muted: false,
  avatar: null,
  team_id: 1,
  role: 1
}];
export const members = [{
  member_id: 2,
  role: '1'
}, {
  member_id: 4,
  role: '2'
}];
export const projectChannels = [{
  uniqueName: '5_client_admin_04102021141131',
  authorAttributes: {
    avatar: '/images/GTI_Logo_Mini@2x.png',
    name: 'GTI staff - project',
    user_id: TWILIO_ADMIN_IDENTITY
  },
  createdBy: 'system',
  lastMessage: {
    dateCreated: 'Fri Oct 08 2021 18:11:39 GMT-0300 (Horário Padrão de Brasília)'
  },
  friendlyName: 'project: Client - GTI Staff',
  sid: 'CHb71ae62a3531481781eb48996fa1c019'
}];